"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var observation_windows_1 = require("../../../common/helpers/observation-windows");
var StudentBookDriveController = /** @class */ (function () {
    function StudentBookDriveController($rootScope, UserService, $state, $stateParams, DrivesModel, FlashService, VueStoreFactory, drive, locations) {
        var _this = this;
        this.DrivesModel = DrivesModel;
        this.$state = $state;
        this.FlashService = FlashService;
        this.$stateParams = $stateParams;
        this.VueStoreFactory = VueStoreFactory;
        var drivePolicy = VueStoreFactory.state.auth.policies.policies.find(function (policy) { return policy.name === "drives"; });
        var useServiceArea = drivePolicy.policymeta.find(function (meta) { return meta.meta_key === "use_service_area"; });
        this.pickupLocation = {};
        this.locations = locations.pickuplocations;
        this.dropofflocations = locations.dropofflocations;
        this.drive = drive;
        this.currentUser = UserService.getCurrentUser();
        this.observer_or_driver = "driver";
        this.selectedSlotId = null;
        this.slots = [];
        if (this.drive.observation === true) {
            // The school has already defined the slots; the student picks an open one.
            this.observer_or_driver = "";
            this.slots = (0, observation_windows_1.availableSlots)(this.drive.slots, this.currentUser.id);
        }
        if (useServiceArea.meta_value === "N") {
            this.drive.location = this.locations[0];
        }
        // this is the location students see if their school's settings do not allow for custom pick-up and
        // drop-off locations
        this.schoolAddress = this.currentUser.school.address;
        this.submitting = false;
        $rootScope.$on("MESSAGE_CLEARED", function () {
            _this.submitting = false;
        });
        if (this.drive.type.allow_custom_dropoff_locations === false) {
            this.dropofflocation = locations.dropofflocations[0];
        }
        if (this.drive.type.allow_custom_pickup_locations === false) {
            this.pickuplocation = locations.pickuplocations[0];
        }
    }
    StudentBookDriveController.prototype.selectSlot = function (slotId) {
        this.selectedSlotId = slotId;
    };
    StudentBookDriveController.prototype.bookDrive = function () {
        var _this = this;
        this.submitting = true;
        var data = {
            drive_id: this.$stateParams.id,
            student_id: this.currentUser.id,
            pickuplocation: this.pickuplocation,
            dropofflocation: this.dropofflocation,
        };
        if (this.drive.observation) {
            data.observer_or_driver = this.observer_or_driver;
            data.slot_id = this.selectedSlotId;
        }
        this.DrivesModel.claimDrive(data)
            .then(function (response) {
            _this.$state.go("drivecoach.student.dashboard", _this.$stateParams, {
                reload: true,
            });
            _this.submitting = false;
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
        })
            .catch(function (Error) {
            _this.submitting = false;
        });
    };
    return StudentBookDriveController;
}());
StudentBookDriveController.$inject = [
    "$rootScope",
    "UserService",
    "$state",
    "$stateParams",
    "DrivesModel",
    "FlashService",
    "VueStoreFactory",
    "drive",
    "locations",
];
exports.default = StudentBookDriveController;
